import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { artikel } from "@/data/magazin";
import { T } from "@/components/T";
import { useLanguage } from "@/contexts/LanguageContext";

export function MagazinTeaser() {
  const { lang } = useLanguage();
  return (
    <section data-testid="magazin-teaser" className="section-gap bg-hb-off-white">
      <div className="container-hb">
        <div className="flex items-end justify-between mb-12">
          <div>
            <span className="label-text block mb-3 reveal"><T de="Holz-Wissen" it="Conoscenza del legno" /></span>
            <h2 className="font-bebas text-hb-dark reveal reveal-delay-1" style={{ fontSize: "clamp(48px, 6.5vw, 88px)", lineHeight: 1 }}>
              <T de="Aus der Praxis." it="Dalla pratica." />
            </h2>
          </div>
          <Link to="/magazin" data-testid="all-artikel-link"
            className="text-[10px] tracking-widest uppercase text-hb-muted hover:text-hb-dark transition-colors font-inter flex items-center gap-2 reveal">
            <T de="Alle Artikel" it="Tutti gli articoli" /> <ArrowRight size={11} />
          </Link>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-px bg-hb-border">
          <Link to={`/magazin/${artikel[0].slug}`} data-testid={`artikel-card-${artikel[0].id}`}
            className="lg:col-span-2 group bg-white overflow-hidden img-zoom reveal">
            <div className="aspect-[16/7] overflow-hidden">
              <img loading="lazy" src={artikel[0].bild} alt={lang === "it" && artikel[0].titel_it ? artikel[0].titel_it : artikel[0].titel}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            </div>
            <div className="p-8">
              <span className="text-[10px] tracking-widest uppercase text-hb-yellow font-semibold block mb-2">{artikel[0].kategorie}</span>
              <h3 className="font-manrope font-bold text-hb-dark text-xl mb-2 group-hover:text-hb-yellow transition-colors leading-tight">
                {lang === "it" && artikel[0].titel_it ? artikel[0].titel_it : artikel[0].titel}
              </h3>
              <p className="text-sm text-hb-text font-inter leading-relaxed">
                {lang === "it" && artikel[0].vorschau_it ? artikel[0].vorschau_it : artikel[0].vorschau}
              </p>
            </div>
          </Link>
          <div className="bg-white flex flex-col">
            {artikel.slice(1, 3).map((a) => (
              <Link key={a.id} to={`/magazin/${a.slug}`} data-testid={`artikel-card-${a.id}`}
                className="group flex-1 overflow-hidden border-b border-hb-border last:border-b-0 reveal">
                <div className="overflow-hidden" style={{ aspectRatio: "16/9" }}>
                  <img loading="lazy" src={a.bild} alt={lang === "it" && a.titel_it ? a.titel_it : a.titel}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
                <div className="p-6">
                  <span className="text-[10px] tracking-widest uppercase text-hb-yellow font-semibold block mb-1">{a.kategorie}</span>
                  <h3 className="font-manrope font-bold text-hb-dark text-sm group-hover:text-hb-yellow transition-colors leading-tight">
                    {lang === "it" && a.titel_it ? a.titel_it : a.titel}
                  </h3>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
